import React from 'react';

import { Premium as CommonPremium } from '../common';

export const Premium = () => {
  return <CommonPremium />;
};
